/*
  Accepts a style definition as a JS object
  Returns an OpenLayers Style object
  This provides access to OL styles in config.js w/o importing OL style constructors
*/

import {Icon, Style, Circle, Fill, Stroke, Text, RegularShape} from '../node_modules/ol/style.js';
import Point from '../node_modules/ol/geom/Point.js';

import FillPattern from '../node_modules/ol-ext/style/FillPattern.js';

export default function (style) {
  let image = null;
  let fill = null;
  let stroke = null;
  let text = null;
  let geom = null;
  if (typeof style === 'string') {  // convert simple color string into an object
    style = { fillColor: style };
  }

  if (style.icon) {
    /*
    image = new Icon({
      // anchor: [0.5, 0.5],
      // size: [52, 52],
      // offset: [0, 0],
      // opacity: 1,
      scale: style.icon.scale || 1,
      src: style.icon.src,
    })
    */
    image = new Icon(style.icon)
  }

  if (style.regularShape) {  // only used in Laramie county 2024-07-04
    if (style.regularShape.fillColor) { // look up the color from this.colors
      style.regularShape.fill = new Fill({ color: this.colors[style.regularShape.fillColor] });
    } else if (style.regularShape?.fill?.color) { // use the color definition
      style.regularShape.fill = new Fill({ color: style.regularShape.fill.color });
    }
    if (style.regularShape.stroke) {
      style.regularShape.stroke = new Stroke({
        color: style.regularShape.stroke.color,
        width: style.regularShape.stroke.width || 1,
      })
    }
    image = new RegularShape(style.regularShape);
  }

  if (style.circle) {
    let fill = null;
    let stroke = null;
    if (style.circle.fillColor) { // look up the color from this.colors
      fill = new Fill({ color: this.colors[style.circle.fillColor] });
    } else if (style.circle?.fill?.color) { // use the color definition
      fill = new Fill({ color: style.circle.fill.color });
    }
    if (style.circle.stroke) {
      stroke = new Stroke({
        color: style.circle.stroke.color,
        width: style.circle.stroke.width || 1,
      })
    }
    image = new Circle({
      radius: style.circle.radius || 2,
      fill: fill,
      stroke: stroke,
    });
  }

  if (style.fillColor) {  // "fillColor" is for choosing a named color from this.colors
    fill = new Fill({ color: this.colors[style.fillColor] });
  } else if (style.fill && style.fill.color) {  // "fill.color" is an actual color definition
    fill = new Fill({ color: style.fill.color });
  }

  /*
     FillPattern comes from ol-ext https://github.com/Viglino/ol-ext and is not in use
     in any projects as of 2024-07-04 but sheridan has some nice examples. It adds 12kb
     to the un-gzipped build. Currently there are no runtime overrides for fillPattern.
  */
  if (style.fillPattern) {
    fill = new FillPattern(style.fillPattern)
    /*  {
      // pattern: (p!='Image (PNG)') ? p : undefined,
      pattern: 'grass', // grass (swamp) "hatch","cross","dot","circle","square","tile"
      // image: (p=='Image (PNG)') ? new ol.style.Icon({ src : imgFile }) : undefined,
      ratio: 1,
      // icon: p=='Image (PNG)' ? new ol.style.Icon ({src:'data/target.png'}) : undefined,
      color: [0, 255, 0],
      offset: 0,
      scale: 1,
      // fill: new Fill ({ color: [255, 0, 0] }),
      size: 3,
      spacing: 6,
      angle: 45,
    } */
  }

  if (style.stroke) {
    style.stroke.color = style.stroke.color || 'rgba(128, 128, 128, 0.8)'
    style.stroke.width = style.stroke.width || 2
    stroke = new Stroke(style.stroke)
  }

  if (style.text) {
    let fill;
    let stroke;
    if (style.text.fill) {
      fill = new Fill({
        color: style.text.fill?.color || '#000000',
      })
    }
    if (style.text.stroke) {
      style.text.stroke.color = style.text.stroke.color || '#ffffff'
      style.text.stroke.width = style.text.stroke.width || 2
      stroke = new Stroke(style.text.stroke)
    }
    text = new Text({
      // backgroundFill	  module:ol/style/Fill~Fill	      Fill style for the text background when placement is 'point'. Default is no fill.
      // backgroundStroke	module:ol/style/Stroke~Stroke	  Stroke style for the text background when placement is 'point'. Default is no stroke.
      fill: fill,   // Fill style. If none is provided, we'll use a dark fill-style (#333).
      font: style.text.font || 'bold 12pt Arial, Helvetica, sans-serif', // Font style as CSS 'font' value, see: https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/font. Default is '10px sans-serif'
      // labelMaxRes: style.text.labelMaxRes || 64,  // appears to be gone in ol6.3
      offsetX: style.text.offsetX,     // Horizontal text offset in pixels. A positive will shift the text right
      offsetY: style.text.offsetY,     // Vertical text offset in pixels. A positive will shift the text down
      overflow: style.text.overflow,   // boolean (defaults to false)	For polygon labels or when placement is set to 'line', allow text to exceed the width of the polygon at the label position or the length of the path that it follows.
      padding: style.text.padding,     // Array.<number> (defaults to [0, 0, 0, 0])	Padding in pixels around the text for decluttering and background. The order of values in the array is [top, right, bottom, left].
      placement: style.text.placement, // module:ol/style/TextPlacement | string (defaults to 'point')
      maxAngle: style.text.maxAngle,   // When placement is set to 'line', allow a maximum angle between adjacent characters. The expected value is in radians, and the default is 45° (Math.PI / 4).
      stroke: stroke,
      text: style.text.text,
      textAlign: style.text.textAlign,  // Text alignment. Possible values: 'left', 'right', 'center', 'end' or 'start'. Default is 'center' for placement: 'point'. For placement: 'line', the default is to let the renderer choose a placement where maxAngle is not exceeded.
      textBaseline:	style.text.textBaseline,  // string (defaults to 'middle')   Text base line. Possible values: 'bottom', 'top', 'middle', 'alphabetic', 'hanging', 'ideographic'.
    });
  }

  if (style.xy) {
    geom = new Point(style.xy)
  } else if (style.geometry) {
    geom = style.geometry // this assumes that geometry is a function
  }

  return new Style({
    fill: fill,
    geometry: geom,  // geometry | geometryFunction
    image: image,
    // renderer:
    stroke: stroke,
    text: text,
    zIndex: style.zIndex,
  })
}
